// routes.jsx - Correct

import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import BackToTopButton from './components/ui/BackToTopButton'; 

import ProjectsPortfolioUniverse from './pages/projectspage';
import BlogKnowledgeInsightsHub from './pages/blogpage';
import Homepage from './pages/homepage';
import AboutPage from './pages/aboutpage';
import ContactPage from './pages/contactpage'
import ServicesPage from './pages/servicespage'

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          <Route path="/" element={<Homepage />} />
          <Route path="/projectspage" element={<ProjectsPortfolioUniverse />} />
          <Route path="/blogpage" element={<BlogKnowledgeInsightsHub />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/aboutpage" element={<AboutPage />} />
          <Route path="/contactpage" element={<ContactPage />} />
          <Route path="/servicespage" element={<ServicesPage />} />

          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      
        {/* BackToTopButton is correctly placed outside RouterRoutes */}
        <BackToTopButton />
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;